import { Routes } from '@angular/router';
import { Public } from './public';

export const PUBLIC_ROUTES: Routes = [
    {
        path: '',
        component: Public,
        children: [
            {
                path: '',
                redirectTo: 'join-class',
                pathMatch: 'full'
            },
            {
                path: 'join-class/:id',
                loadComponent: () => import('./pages/join-class/join-class').then(m => m.JoinClass)
            },
            {
                path: 'email-sent',
                loadComponent: () => import('./pages/email-sent/email-sent').then(m => m.EmailSent)
            },
            {
                path: 'unverified-email',
                loadComponent: () => import('./pages/unverified-email/unverified-email').then(m => m.UnverifiedEmail)
            },
            {
                path: 'update-data',
                loadComponent: () => import('./pages/update-data/update-data').then(m => m.UpdateData),
                children: [
                    {
                        path: '',
                        redirectTo: 'phone-verification',
                        pathMatch: 'full'
                    },
                    {
                        path: 'phone-verification',
                        loadComponent: () => import('./pages/update-data/pages/phone-verification/phone-verification').then(m => m.PhoneVerification)
                    },
                    {
                        path: 'student-info',
                        loadComponent: () => import('./pages/update-data/pages/student-info/student-info').then(m => m.StudentInfo)
                    },
                    {
                        path: 'email-sent',
                        loadComponent: () => import('./pages/update-data/pages/email-update-data-sent/email-update-data-sent').then(m => m.EmailUpdateDataSent)
                    },
                    {
                        path: 'success',
                        loadComponent: () => import('./pages/update-data/pages/update-data-success/update-data-success').then(m => m.UpdateDataSuccess)
                    }
                ]
            },
            {
                path: 'privacy-policy',
                loadComponent: () => import('./pages/privacy-policy/privacy-policy').then(m => m.PrivacyPolicy)
            },
            {
                path: 'terms-of-service',
                loadComponent: () => import('./pages/terms-of-service/terms-of-service').then(m => m.TermsOfService)
            },
            {
                path: '**',
                loadComponent: () => import('./pages/public-not-found/public-not-found').then(m => m.PublicNotFound)
            }
        ]
    }
];
